import { defineMessages } from 'react-intl';

const messages = defineMessages({
  acceptInvitation: {
    id: 'pages.loginPage.acceptInvitation',
    defaultMessage: 'Accept Invitation',
  },
  acceptInvitationDescription: {
    id: 'pages.loginPage.acceptInvitationDescription',
    defaultMessage: 'We welcome you!',
  },
  acceptInvitationSubDescription: {
    id: 'pages.loginPage.acceptInvitationSubDescription',
    defaultMessage:
      'By accepting this invitation you will be able to access the platform.',
  },
  acceptTerms: {
    id: 'pages.registerPage.acceptTerms',
    defaultMessage: 'I accept <link>terms and conditions</link>',
  },
  accessForbidden: {
    id: 'notFoundPage.accessForbidden',
    defaultMessage: 'Access Forbidden',
  },
  appTitle: {
    id: 'pages.appTitle',
    defaultMessage: 'My Fit World',
  },
  backToHome: {
    id: 'pages.loginPage.backToHome',
    defaultMessage: 'Back to Home',
  },
  checkSchedule: {
    id: 'pages.dashboardPage.checkSchedule',
    defaultMessage: 'Check Schedule',
  },
  confirmPasswordLabel: {
    id: 'pages.auth.confirmPasswordLabel',
    defaultMessage: 'Confirm password',
  },
  done: {
    id: 'pages.loginPage.done',
    defaultMessage: 'Done',
  },
  emailLabel: {
    id: 'pages.auth.emailLabel',
    defaultMessage: 'Email',
  },
  forgotPassowrdDescription: {
    id: 'pages.loginPage.forgotPassowrdDescription',
    defaultMessage: 'You remembered your Account?',
  },
  forgotPassowrdTitle: {
    id: 'pages.forgotPasswordPage.forgotPassowrdTitle',
    defaultMessage: 'Forgot Password',
  },
  forgotPasswordBackToSingIn: {
    id: 'pages.loginPage.forgotPasswordBackToSingIn',
    defaultMessage: 'Back to Sign In',
  },
  loginCreateAnAccount: {
    id: 'pages.loginPage.loginCreateAnAccount',
    defaultMessage: 'Create an Account',
  },
  loginDescription: {
    id: 'pages.loginPage.loginDescription',
    defaultMessage: "You don't have an account already? Then",
  },
  loginForgotPassword: {
    id: 'pages.loginPage.loginForgotPassword',
    defaultMessage: 'Forgot password',
  },
  loginRememberMe: {
    id: 'pages.loginPage.loginRememberMe',
    defaultMessage: 'Remember me',
  },
  loginSuccessNotification: {
    id: 'pages.loginPage.loginSuccessNotification',
    defaultMessage: 'Welcome',
  },
  loginTitle: {
    id: 'pages.loginPage.loginTitle',
    defaultMessage: 'SIGN IN',
  },
  nameLabel: {
    id: 'pages.auth.nameLabel',
    defaultMessage: 'Name',
  },
  orTitle: {
    id: 'pages.loginPage.orTitle',
    defaultMessage: 'OR',
  },
  pageNotFoundTitle: {
    id: 'notFoundPage.pageNotFoundTitle',
    defaultMessage: 'Page not found',
  },
  passwordLabel: {
    id: 'pages.auth.passwordLabel',
    defaultMessage: 'Password',
  },
  registerDescription: {
    id: 'pages.registerPage.registerDescription',
    defaultMessage: 'You don`t have an Account already? Then',
  },
  registerFailed: {
    id: 'confirmUserPage.registerFailed',
    defaultMessage:
      'We could not finish your reservation. Please try again or contact our support.',
  },
  registerSucceeded: {
    id: 'confirmUserPage.registerSucceeded',
    defaultMessage: 'Registration completed successfully! You can now sign in.',
  },
  registerTitle: {
    id: 'pages.registerPage.registerTitle',
    defaultMessage: 'Sign Up',
  },
  routeErrorDescription: {
    id: 'pages.routeError.description',
    defaultMessage:
      'An unexpected error occurred. Refresh the page to continue.',
  },
  routeErrorRefresh: {
    id: 'pages.routeError.refresh',
    defaultMessage: 'Refresh',
  },
  routeErrorTitle: {
    id: 'pages.routeError.title',
    defaultMessage: 'Something went wrong',
  },
  signInWithGoogle: {
    id: 'pages.loginPage.signInWithGoogle',
    defaultMessage: 'Sign in with Google',
  },
});

export default messages;
